import { useTranslation } from 'react-i18next';
import { usePatientTabs } from './patient-tabs.js';
import { UnsavedChangesDialog } from './UnsavedChangesDialog.js';

/**
 * Garde de navigation. En V1 elle ne couvrait que `/patients/:id` ; ici elle est posée sur la
 * source de localisation du routeur, donc sur toute navigation interne, quel que soit l'écran.
 */
export function NavigationGuardDialog() {
  const { t } = useTranslation();
  const {
    pendingNavigation,
    confirmPendingNavigation,
    cancelPendingNavigation,
    dirtySnapshot,
    saveRegion,
    discardRegion,
  } = usePatientTabs();

  return (
    <UnsavedChangesDialog
      open={pendingNavigation !== null}
      testId="dialog-navigation-guard"
      title={t('shell:tabs.unsaved')}
      description={t('shell:tabs.navigation_description')}
      discardLabel={t('shell:tabs.continue_without_saving')}
      saveLabel={t('shell:tabs.save_and_continue')}
      snapshot={pendingNavigation === null ? [] : dirtySnapshot()}
      showGroupNames
      saveRegion={saveRegion}
      discardRegion={discardRegion}
      onCancel={cancelPendingNavigation}
      onProceed={confirmPendingNavigation}
    />
  );
}
